export const theme = {
    breakpoint: 767,
    colors: {
        background: "rgb(226, 226, 226)",
        primaryColor: "teal",
        activeColor: "hsl(180, 100%, 35%)",
    },
}